import styled from 'styled-components';
import { Spacing4, Spacing8, Spacing16 } from 'autogen/design-tokens/tokens';
import { ActiveFilterViewModelDiscriminator, type ProductListResultViewModel } from 'autogen/swagger/all';
import ScrollSnapSlider, { useScrollSnapSlider } from 'components/generic/ScrollSnapSlider';
import { invisibleScrollbar } from 'modules/helpers/mixins';
import { breakpoint, sizes } from 'variables';
import ClearAllActiveFiltersButton from './components/ClearAllActiveFiltersButton';
import ColorActiveFilterOption from './components/ColorActiveFilterOption';
import SimpleActiveFilterOption from './components/SimpleActiveFilterOption';

/* #region styles */
const StyledScrollSnapSlider = styled(ScrollSnapSlider)`
    && {
        gap: ${Spacing4};
        padding: 0 ${Spacing16};
        margin: 0 -${Spacing16};
        scroll-padding-inline-end: ${Spacing16};
        scroll-padding-inline-start: ${Spacing16};
        ${invisibleScrollbar()}

        ${breakpoint.up(sizes.sm)} {
            padding: 0;
            margin: 0;
            gap: ${Spacing8};

            display: flex;
            flex-wrap: wrap;
            overflow: hidden;
        }
    }
`;
/* #endregion */

const options = {
    draggable: true,
    loop: false
};

export default function ActiveFiltersRenderer({
    model: { activeFilterValues: activeFilterOptions }
}: {
    model: ProductListResultViewModel;
}) {
    const { ref } = useScrollSnapSlider(options);

    if (!activeFilterOptions.length) return null;

    return (
        <StyledScrollSnapSlider ref={ref}>
            {activeFilterOptions.map((activeFilterOption) =>
                ActiveFilterViewModelDiscriminator(
                    activeFilterOption,
                    (simpleActiveFilterModel) => (
                        <SimpleActiveFilterOption key={activeFilterOption.value} model={simpleActiveFilterModel} />
                    ),
                    (colorActiveFilterModel) => (
                        <ColorActiveFilterOption key={activeFilterOption.value} model={colorActiveFilterModel} />
                    ),
                    () => null
                )
            )}
            <ClearAllActiveFiltersButton model={activeFilterOptions} />
        </StyledScrollSnapSlider>
    );
}
